<script setup lang="ts">
type PolicyTab = 'service' | 'privacy'

const route = useRoute()

// 兼容旧的 query 入口：老链接默认展示服务政策，type=3 时展示隐私政策。
const resolveLegacyPolicyTab = (type: unknown): PolicyTab => {
  return String(type || '') === '3' ? 'privacy' : 'service'
}

const activeTab = computed<PolicyTab>(() => resolveLegacyPolicyTab(route.query.type))
</script>

<template>
  <TermsPolicyPage :tab="activeTab" />
</template>
